var _circle, _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5.58313,
    fill: "url(#paint0_linear_106_81283)",
    stroke: "#4F56DD",
    strokeWidth: 0.833747
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.42721 9.20142H6.83862V7.61283L8.42721 9.20142Z",
    fill: "#3F45B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74198 9.20142H5.33057V7.61283L3.74198 9.20142Z",
    fill: "#3F45B7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_81283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.96728 2.87001L9.17278 4.82227L7.5185 4.49347L7.05612 9.09668H5.05249L4.59012 4.49347L2.92556 4.82227L3.13106 2.87001H8.96728Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_81283",
    x: 0.870531,
    y: 2.87012,
    width: 10.3573,
    height: 10.3366,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.05501
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.0275
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_81283"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_81283",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_81283",
    x1: 6,
    y1: 0,
    x2: 6,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F56DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F56DD",
    stopOpacity: 0.83
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTCoin);
export default __webpack_public_path__ + "static/media/T_coin.748f67c447c27df8b5631fb444551f52.svg";
export { ForwardRef as ReactComponent };